/**
 * Ornate decorative frame — corner flourishes around important content.
 * Used to "ceremonialise" the card-of-day box and onboarding splash.
 */
interface Props {
  children: React.ReactNode;
  className?: string;
}

const Corner = ({ rotate }: { rotate: number }) => (
  <svg
    viewBox="0 0 40 40"
    className="absolute h-6 w-6 text-gold-500"
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    <path
      d="M2 12 Q 2 2, 12 2 L 16 2 M 2 12 L 2 16 M 8 2 L 8 8 Q 8 12, 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <circle cx="14" cy="14" r="1.4" fill="currentColor" />
  </svg>
);

export default function OrnateFrame({ children, className = '' }: Props) {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute -left-1 -top-1"><Corner rotate={0} /></div>
      <div className="absolute -right-1 -top-1"><Corner rotate={90} /></div>
      <div className="absolute -left-1 -bottom-1"><Corner rotate={270} /></div>
      <div className="absolute -right-1 -bottom-1"><Corner rotate={180} /></div>
      {children}
    </div>
  );
}
